import React, { useState } from 'react';
import { buildVariantUrl, getPhotoVersion, usePhotoVariants } from '../utils/photoCache';
import ProgressiveImage from './ProgressiveImage';

// Keep a real thumbnail in the zoom target until the full-size image is decoded.
export default function PhotoViewerImage({ image, active = true, thumbnailVariant = 'sm', ...props }) {
  const identity = `${image.id || image.filename}:${getPhotoVersion(image)}:${image.url || ''}`;
  const [fallback, setFallback] = useState({ identity: null, origin: false, variant: 'xl' });
  const currentFallback = fallback.identity === identity ? fallback : { origin: false, variant: 'xl' };
  const target = currentFallback.origin ? { ...image, _force_origin: true } : image;
  // Public shares provide an authorized URL; never also request private media.
  const variants = usePhotoVariants(active && !image.url ? target : null, { variants: [currentFallback.variant] });
  const full = image.url || variants[currentFallback.variant];
  const onFullError = () => {
    if (image.url) return;
    if (image.cdn_urls && !currentFallback.origin) {
      setFallback({ identity, origin: true, variant: 'xl' });
    } else if (currentFallback.variant === 'xl') {
      setFallback({ identity, origin: currentFallback.origin, variant: 'lg' });
    }
  };

  // A cached blob belongs to the hook and is released when this slide leaves
  // the active window. Do not keep a revoked URL on an offscreen slide.
  return <ProgressiveImage
    {...props}
    src={full}
    previewSrc={image._previewSrc || image.preview_url || (image.url ? image.url : buildVariantUrl(image, thumbnailVariant))}
    identity={identity}
    active={active}
    onFullError={onFullError}
    alt={image.title || 'Photo'}
  />;
}
